import { render } from "./FuelType.vue?vue&type=template&id=2422a13e"
import script from "./FuelType.vue?vue&type=script&lang=js"
export * from "./FuelType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__